import React, { useState } from "react";
import Modal from "../../common/Modal";
import MonthYearSelect from "../../common/MonthYearSelect";
import { getValuesForMonthsYearsSelect } from "../../../lib/utils";
import ExportCSVButton from "../../shared/ExportCSVButton";

export default function KpiScoresExportModal(props) {
  const { getLocationsForExport } = props;

  const [selectedDate, setSelectedDate] = useState(null);

  const monthYearsArray = getValuesForMonthsYearsSelect(60);

  const getScoreForCategory = (fieldName, metricShortName, metricLongName) => ({
    label: `${metricShortName} KPI Score`,
    value: ({ [fieldName]: metrics }) =>
      metrics?.kpis.find((kpi) => kpi.category === metricLongName).score,
  });

  const getValueForCategory = (fieldName, label, metricLongName) => ({
    label: label,
    value: ({ [fieldName]: metrics }) =>
      metrics?.kpis.find((kpi) => kpi.category === metricLongName).value,
  });

  const getNumeratorValueForCategory = (fieldName, label, metricLongName) => ({
    label: label,
    value: ({ [fieldName]: metrics }) =>
      metrics?.kpis.find((kpi) => kpi.category === metricLongName)
        .numeratorValue,
  });

  const getKpiMetricsExportHeaders = (fieldName) => [
    {
      label: "Total KPI Score",
      value: `${fieldName}.totalScore`,
    },
    getScoreForCategory(fieldName, "Students", "UniqueStudentsInteractedWith"),
    getScoreForCategory(
      fieldName,
      "Percentage",
      "PercentageOfJewishStudentsInteractedWith"
    ),
    getScoreForCategory(fieldName, "Engagements", "TotalEngagements"),
    getScoreForCategory(
      fieldName,
      "Frequency",
      "PercentageOfStudentsWith3PlusEngagements"
    ),
    getScoreForCategory(
      fieldName,
      "Depth",
      "PercentageOfStudentsWith5PlusFlames"
    ),
    getValueForCategory(
      fieldName,
      "Students Reached",
      "UniqueStudentsInteractedWith"
    ),
    getValueForCategory(
      fieldName,
      "Percentage of Students Reached",
      "PercentageOfJewishStudentsInteractedWith"
    ),
    getValueForCategory(fieldName, "Engagements", "TotalEngagements"),
    getNumeratorValueForCategory(
      fieldName,
      "Frequent Students",
      "PercentageOfStudentsWith3PlusEngagements"
    ),
    getValueForCategory(
      fieldName,
      "Percentage of Frequent Students",
      "PercentageOfStudentsWith3PlusEngagements"
    ),
    getNumeratorValueForCategory(
      fieldName,
      "Deep Engagements",
      "PercentageOfStudentsWith5PlusFlames"
    ),
    getValueForCategory(
      fieldName,
      "Percentage of Deep Engagements",
      "PercentageOfStudentsWith5PlusFlames"
    ),
  ];

  const onClose = () => {
    setSelectedDate(null);
    props.onClose();
  };

  const onSelectMonthYear = (selectedDate) => {
    setSelectedDate(selectedDate);
  };

  const getKpiExportHeaders = () => [
    { label: "Chabad House ID", value: "chabadHouseID" },
    { label: "Chabad House", value: "chabadHouseName" },
    { label: "Campus ID", value: "campusID" },
    { label: "Campus", value: "campusName" },
    { label: "Shliach ID", value: "shliachID" },
    { label: "Shliach First Name", value: "shliachFirstName" },
    { label: "Shliach Last Name", value: "shliachLastName" },
    { label: "Shlucha ID", value: "shluchaID" },
    { label: "Shlucha First Name", value: "shluchaFirstName" },
    { label: "Shlucha Last Name", value: "shluchaLastName" },
    { label: "Shliach Email", value: "shliachEmail" },
    { label: "Shliach Cell", value: "shliachCell" },
    { label: "Shlucha Email", value: "shluchaEmail" },
    { label: "Shlucha Cell", value: "shluchaCell" },
    ...getKpiMetricsExportHeaders("monthYearMetrics"),
  ];

  return (
    <Modal className="medium-modal">
      <p className="large-text fw-500 mb-16">Select Month</p>
      <MonthYearSelect
        onChange={onSelectMonthYear}
        value={selectedDate}
        monthYearsArray={monthYearsArray}
      />
      <div className="text-right mt-24">
        <div className="flex" style={{ columnGap: "16px", float: "right" }}>
          <button className="btn link-text uppercase-text" onClick={onClose}>
            Cancel
          </button>
          <ExportCSVButton
            className="btn custom-btn btn-accent flex flex-align-center"
            fileName="Engagement_Portal_KPI_Scores"
            getExportData={() => getLocationsForExport("kpi", selectedDate)}
            getHeaders={getKpiExportHeaders}
            title="Export KPI Scores"
            disabled={!selectedDate}
          />
        </div>
      </div>
    </Modal>
  );
}
